export default "__VITE_ASSET__DCGzOvNM__"